import styled from "styled-components";

export const Container = styled.div`
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto minmax(0, 1fr) auto;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.alabaster};

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto minmax(0, 1fr);
    min-height: 100vh;
       height: 100%;
  }
`;
